export const recommendedLoadsTriggerDatesQuery = (dotNumber) => ({
  collection: `recommendedLoadsTrigger`,
  doc: `${dotNumber}`,
  storeAs: `recommendedLoadsTrigger`,
});

export const getRecommendedLoadsTriggerDates = companyKey => [
  'firestore',
  'data',
  `recommendedLoadsTrigger`,
];
